// extracted by mini-css-extract-plugin
module.exports = {"i1sd3sn6":"i1sd3sn6","a6q2sn4":"a6q2sn4"};